import { buildSlice, CommentState } from '@24sens/ecg01-comments';

const slice = buildSlice((state: { comment: CommentState }) => state.comment);

export default slice;
export const selectors = slice.selectors;
